import Icon from '../Icon.vue'

Icon.register({
  'menu_home': {
    width: 16,
    height: 13,
    paths: [
      {
        d: 'M7.789 3.218L2.685 7.422v4.536c0 .245.198.443.443.443l3.102-.008c.244 0 .44-.199.44-.443V9.301c0-.245.199-.443.444-.443h1.771c.245 0 .443.198.443.443v2.648a.443.443 0 00.443.444l3.101.008a.443.443 0 00.443-.443v-4.54l-5.103-4.2c-.123-.1-.3-.1-.423 0zm8.062 2.857L8.843.305a1.329 1.329 0 00-1.688 0L.148 6.074a.332.332 0 00-.044.468l.705.858a.332.332 0 00.469.045l6.51-5.363c.124-.1.3-.1.424 0l6.512 5.363a.332.332 0 00.468-.044l.706-.858a.332.332 0 00-.047-.469z'
      }
    ]
  }
})
